import type { RawTeamFields, TeamSearchFields } from '../types';
import { toMailingAddress } from './address';

/** Maps a raw identity team item onto the feature's search-fields shape. */
export function toTeamSearchFields(team: RawTeamFields): TeamSearchFields {
  return {
    id: team.id,
    legalName: team.legalName,
    alias: team.alias,
    logoUri: team.logoUri,
    logoHorizontalUri: team.logoHorizontalUri,
    status: team.status,
    mailingAddress: toMailingAddress(team.mailingAddress),
  };
}
